// Generated by psc version 0.10.2
"use strict";
var $foreign = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-partial/src/Partial.js");
var crash = function (dictPartial) {
    return $foreign.crashWith(dictPartial)("Partial.crash: partial function");
};
module.exports = {
    crash: crash, 
    crashWith: $foreign.crashWith
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-partial/src/Partial.purs
// module id = 103
// module chunks = 0